import reportingModalStore from '@/store/reportingmodal';

export default {
	name: 'communityReportApp',
	store: reportingModalStore,
	computed: {
		modalParams() {
			return Grabcad.reportingModalStore.state.modalParams;
		},
		activeModal() {
			return Grabcad.reportingModalStore.state.activeModal;
		}
	},
	methods: {
		deactivateModal() {
			Grabcad.reportingModalStore.commit('deactivateModal');
		}
	}
}
